/* eslint-disable no-bitwise -- bit math is deliberate here */
import { v4 as uuid } from 'uuid';

import { canUseDOM } from './components/helpers/dom';

function uuidv4MathRandom() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16); // 0–15
    const v = c === 'x' ? r : (r & 0x3) | 0x8; // variant: 10xx

    return v.toString(16);
  });
}

export function v4() {
  return canUseDOM() ? uuid() : uuidv4MathRandom();
}
